import { capitalize } from 'lodash';

// Real per-word title case (first letter of each word capitalized, rest
// lowercased) -- e.g. "AMOXICILLIN CLAVULANATE" -> "Amoxicillin Clavulanate".
// Mirrors casingFormat in common/utils.js, but kept as its own lightweight
// module (same rationale as formatDrugLabel.js) so API modules and
// queue/table components that need it don't pull in common/utils.js's
// heavier dependencies (pdfjs-dist, jspdf, zpl-renderer-js).
const titleCase = (str) => str?.trim().split(/\s+/).map(capitalize).join(' ');

// Shared shape-agnostic mapper: title-cases drugName/strength/displayName/medicationName on any
// item that carries them, before the item reaches Redux or local component state. Applying this
// once at each api/* module's response boundary means every consumer -- Redux-backed or not --
// gets correctly-cased text without re-formatting it at each render site.
export const withTitleCasedDrugFields = (item) => ({
  ...item,
  ...(item.drugName ? { drugName: titleCase(item.drugName) } : {}),
  ...(item.strength ? { strength: titleCase(item.strength) } : {}),
  ...(item.displayName ? { displayName: titleCase(item.displayName) } : {}),
  ...(item.medicationName ? { medicationName: titleCase(item.medicationName) } : {}),
});

// For organisation names (partner, practice, vendor). Lifts an all-lowercase word but
// leaves any word that already has a capital, so "CVS Health" survives where titleCase
// would flatten it to "Cvs Health".
export const capitalizeName = (value) => {
  if (typeof value !== 'string') return value;

  return value
    .trim()
    .split(/\s+/)
    .map((word) => (/[A-Z]/.test(word) ? word : capitalize(word)))
    .join(' ');
};

export default titleCase;
